module.exports = __webpack_public_path__ + "static/hero-2-0ebccb3b10fad38b934a0ec56610aff0.svg";